/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';

function AppCheckBox({
  id,
  name,
  labelText,
  onChange,
  labelClassName,
  checked,
  radioClassName,
  ...rest
}) {
  return (
    <label
      className={` d-flex ${labelClassName} fw-500 align-items-center fs-12 app-check-box cursor-pointer`}
      // htmlFor={id}
      style={{ color: checked ? '#1e1e1e' : '#768391' }}
    >
      <input
        id={id}
        type="checkbox"
        className={radioClassName}
        name={name}
        checked={checked}
        onChange={onChange}
        {...rest}
        style={{
          marginRight: '7px',
          appearance: 'none',
          width: '15px',
          minWidth: '15px',
          height: '15px',
          borderRadius: '3px',
          border: '1px solid #ccc',
          cursor: 'pointer',
        }}
      />
      {labelText}
    </label>
  );
}

AppCheckBox.defaultProps = {
  labelClassName: '',
  radioClassName: '',
  labelText: '',
  checked: false,
};

AppCheckBox.propTypes = {
  checked: PropTypes.bool,
  labelText: PropTypes.any,
  labelClassName: PropTypes.string,
  radioClassName: PropTypes.string,
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default AppCheckBox;
